import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { Form, Formik, Field } from "formik";
import { Link } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import Button from "../../components/Button/Button";
import FormInput2 from "../../components/FormInput/FormInput2";
import Nibss from "../../assets/assets/Nibss-Logo.png";
import { EmailSchema } from "../../utils/validation";
import { clearPasswordResetState, resetPassword } from "../../redux/Actions/PasswordActions";
import Alert from "../../utils/Alert";
import { PropTypes } from "prop-types";
import Button2 from "../../components/Button/Button2";

const ResendEmail = ({ resetPassword, isLoading, mailSentSuccess, clearState }) => {
  const history = useHistory();

  const [state, setState] = useState({
    email: "",
  });

  const initialValues = {
    email: "",
  };

  const submitValues = (values) => {
    setState({
      email: values.email.trim(),
    });
    const payload = {
      email: values.email.trim(),
      type: "user"
    };
    resetPassword(payload);
  };

  const goToLogin = () => {
    history.push("/login");
  };


  useEffect(
    () => {
      if (mailSentSuccess) {
        Alert(
          true,
          "success",
          "success message",
          "A code has been sent to your mail."
        );
        document.getElementById("form").reset();
        clearState()
        history.push({
          pathname: "/password-recovery",
          state: state.email,
        });
      }
    },
    // eslint-disable-next-line
    [mailSentSuccess]
  );

  return (
    <div className="reset-password-wrap">
      <Link to="/">
        <div className="reset-password-logo">
          <img src={Nibss} alt="nibss-logo" />
        </div>
      </Link>
      <div className="reset-password-body">
        <div className="reset-password-form-container">
          <div className="reset-password-text">
            <div className="reset-password-text-header">Forgot password</div>
            <div className="reset-password-text-body">
              Enter your email and a verification code will be sent to you
            </div>
          </div>
          <div className="reset-password-form-body">
            <Formik
              initialValues={initialValues}
              onSubmit={submitValues}
              validationSchema={EmailSchema}
            >
              {({ values, handleSubmit, isValid, dirty }) => {
                return (
                  <Form id="form">
                    <div className="reset-password-form-wrap">
                      <div className="form-input">
                        <Field
                          name="email"
                          label="Email"
                          placeholder="Enter email"
                          component={FormInput2}
                        />
                      </div>
                    </div>

                    <div className="reset-button">
                      <Button2
                        word={"BACK"}
                        width="45%"
                        onClick={goToLogin}
                      />
                      <Button
                        word={"SEND"}
                        width="45%"
                        disabled={!(isValid && dirty)}
                        img={isLoading ? <Loader /> : ""}
                      />
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  resetPassword: (payload) => dispatch(resetPassword(payload)),
  clearState: () => dispatch(clearPasswordResetState())
});

const mapStateToProps = (state) => ({
  isLoading: state.password.isSendingMail,
  mailSentSuccess: state.password.mailSentSuccess,
});

ResendEmail.propTypes = {
  resetPassword: PropTypes.func,
  isLoading: PropTypes.bool,
  mailSentSuccess: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResendEmail);
